import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=85c72964&scoped=true&"
import script from "./Flow.vue?vue&type=script&lang=js&"
export * from "./Flow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/_flow.scss?vue&type=style&index=0&id=85c72964&scoped=true&lang=scss&"
import style1 from "./Flow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c72964",
  null
  
)

export default component.exports